import { atom } from "recoil";

export const selectColorValueState = atom({
  key: "selectColorValueState",
  default: {},
});
